import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteOptionValue } from '../../../api/apiOptionGroups';
import { toast } from 'react-hot-toast';
import parseError from '../../../utils/parseError';

/**
 * Hook to delete an option value
 */
export const useDeleteOptionValue = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteOptionValueMutate, isPending: isDeleting } = useMutation({
        mutationFn: ({ optionGroupId, valueId }) => deleteOptionValue(optionGroupId, valueId),
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['optionValues'] });
            toast.success(res?.data?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { deleteOptionValueMutate, isDeleting };
};
